export default __webpack_public_path__ + "static/media/1.200ff9e0.png";